import type { MapGeojsonProps } from "./map-geojson.type";
import type { GM_Data } from "../map.type";

import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useRef } from "react";

import { getMapGeojsonFeatureStyle } from "./map-geojson.helper";

const MapGeojson = ({ geojson, options }: MapGeojsonProps) => {
  const map = useMap();
  const dataLayerRef = useRef<GM_Data>(null);

  useEffect(() => {
    // Remove previous layer if any
    if (dataLayerRef.current) {
      dataLayerRef.current.setMap(null);
      dataLayerRef.current = null;
    }

    if (!map) return;

    // Create a new Data Layer
    const dataLayer = new google.maps.Data({ map });
    dataLayer.addGeoJson(geojson);
    dataLayer.setStyle((feature) =>
      getMapGeojsonFeatureStyle(feature, options)
    );
    dataLayerRef.current = dataLayer;

    // Cleanup on unmount
    return () => {
      if (dataLayerRef.current) {
        dataLayerRef.current.setMap(null);
        dataLayerRef.current = null;
      }
    };
  }, [map, geojson, options]);

  return null;
};

export default MapGeojson;
